import { Card } from '../card/card'
import { QuickView } from '../../../sections/product/quick-view'
import { $el } from 'src/scripts/utils/utils'

const QUICK_VIEW_BUTTON_SELECTOR = '[data-product-card-quick-view-button]'
const QUICK_VIEW_SELECTOR = '#Quick-view'

export class VerticalProductCard extends Card {
  mountComponent(): void {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR, this)
    this.addListener(quickViewBtn, 'click', this.handleQuickViewBtnClick)
  }

  handleQuickViewBtnClick = async (): Promise<void> => {
    const quickView: QuickView = $el(QUICK_VIEW_SELECTOR)
    const url = this.dataset.url
    const id = this.dataset.id

    if (!quickView || !url || !id) {
      return
    }

    await quickView.requestProductFromUrl(url, id)
    await quickView.openAndRenderProductByUrl(url)
  }
}
